import React, { useState } from "react";
import BannerTitle from "../../common/components/BannerTitle";
import { GlobalContainer } from "../../common/components/Container";
import ServicesTable from "./components/Services/ServicesTable";
import AlignerMaterialsTable from "./components/AlignerMaterials/AlignerMaterialsTable";
import SourcesTable from "./components/Sources/SourcesTable";
import ModeOfPaymentsTable from "./components/ModeOfPayment/ModeOfPaymentTable";
import TermsOfPayment from "./components/TermsOfPayment/TermsOfPayment";
import TreatmentTypesTable from "./components/TreatmentTypes/TreatmentTypesTable";
import { Box } from "@mui/material";
import { StyledTabs } from "../../common/components/TabPanel/styles";
import { Tab } from "@mui/material";
import { TabPanel } from "../../common/components/TabPanel";
import { Grid } from "@mui/material";
import { Snackbar, Alert } from "@mui/material";
import DailyScheduleTable from "./components/DailySchedule/DailyScheduleTable";
const Settings = () => {
  const [tabValue, setTabValue] = useState(0);
  const [openAlertSnackBar, setOpenAlertSnackBar] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");

  const handleOpenAlert = () => {
    setOpenAlertSnackBar(true);
  };

  const handleCloseAlert = () => {
    setOpenAlertSnackBar(false);
  };

  const handleSetAlertMessage = (message, isSuccess) => {
    setAlertMessage(message);
  };

  const handleTabChange = (e, newValue) => {
    setTabValue(newValue);
  };
  return (
    <GlobalContainer theme="purple" bgColor={"#F0F0F0"}>
      <Snackbar
        open={openAlertSnackBar}
        autoHideDuration={6000}
        onClose={handleCloseAlert}
      >
        <Alert
          variant="filled"
          onClose={handleCloseAlert}
          severity={"error"}
          sx={{ width: "100%" }}
        >
          {alertMessage}
        </Alert>
      </Snackbar>
      <BannerTitle type="banner" theme="purple">
        Settings
      </BannerTitle>
      <StyledTabs
        value={tabValue}
        onChange={handleTabChange}
        variant="scrollable"
        scrollButtonss
        allowScrollButtonsMobile
        TabIndicatorProps={{
          style: { display: "none" },
        }}
      >
        <Tab label="Terms of Payment Before Design" />
        <Tab label="Terms of Payment After Design" />
        <Tab label="Modes of Payment" />
        <Tab label="Sources" />
        <Tab label="Aligner Materials" />
        <Tab label="Services" />
        <Tab label="Treatment Types" />
        <Tab label="Daily Schedule" />
      </StyledTabs>
      <TabPanel value={tabValue} index={0}>
        <div
          style={{
            marginBottom: "20px",
            paddingTop: "5px",
            padding: "20px",
            backgroundColor: "white",
            borderRadius: "10px",
            borderTopLeftRadius: "0px",
            borderTopRightRadius: "0px",
          }}
        >
          <Grid Container direction="row">
            <TermsOfPayment
              theme="purple"
              handleOpenAlert={handleOpenAlert}
              handleSetAlertMessage={handleSetAlertMessage}
              isTabBeforeDesign={true}
            />
          </Grid>
        </div>
      </TabPanel>

      <TabPanel value={tabValue} index={1}>
        <div
          style={{
            marginBottom: "20px",
            paddingTop: "5px",
            padding: "20px",
            backgroundColor: "white",
            borderRadius: "10px",
            borderTopLeftRadius: "0px",
            borderTopRightRadius: "0px",
          }}
        >
          <Grid Container direction="row">
            <TermsOfPayment
              theme="purple"
              handleOpenAlert={handleOpenAlert}
              handleSetAlertMessage={handleSetAlertMessage}
              isTabBeforeDesign={false}
            />
          </Grid>
        </div>
      </TabPanel>
      <TabPanel value={tabValue} index={2}>
        <div
          style={{
            marginBottom: "20px",
            paddingTop: "5px",
            padding: "20px",
            backgroundColor: "white",
            borderRadius: "10px",
            borderTopLeftRadius: "0px",
            borderTopRightRadius: "0px",
          }}
        >
          <Grid Container direction="row">
            <ModeOfPaymentsTable theme="purple" />
          </Grid>
        </div>
      </TabPanel>

      <TabPanel value={tabValue} index={3}>
        <div
          style={{
            marginBottom: "20px",
            paddingTop: "5px",
            padding: "20px",
            backgroundColor: "white",
            borderRadius: "10px",
            borderTopLeftRadius: "0px",
            borderTopRightRadius: "0px",
          }}
        >
          <Grid Container direction="row">
            <SourcesTable
              theme="purple"
              handleOpenAlert={handleOpenAlert}
              handleSetAlertMessage={handleSetAlertMessage}
            />
          </Grid>
        </div>
      </TabPanel>

      <TabPanel value={tabValue} index={4}>
        <div
          style={{
            marginBottom: "20px",
            paddingTop: "5px",
            padding: "20px",
            backgroundColor: "white",
            borderRadius: "10px",
            borderTopLeftRadius: "0px",
            borderTopRightRadius: "0px",
          }}
        >
          <Grid Container direction="row">
            <AlignerMaterialsTable
              theme="purple"
              handleOpenAlert={handleOpenAlert}
              handleSetAlertMessage={handleSetAlertMessage}
            />
          </Grid>
        </div>
      </TabPanel>

      <TabPanel value={tabValue} index={5}>
        <div
          style={{
            marginBottom: "20px",
            paddingTop: "5px",
            padding: "20px",
            backgroundColor: "white",
            borderRadius: "10px",
            borderTopLeftRadius: "0px",
            borderTopRightRadius: "0px",
          }}
        >
          <Grid Container direction="row">
            <ServicesTable theme="purple" />
          </Grid>
        </div>
      </TabPanel>

      <TabPanel value={tabValue} index={6}>
        <div
          style={{
            marginBottom: "20px",
            paddingTop: "5px",
            padding: "20px",
            backgroundColor: "white",
            borderRadius: "10px",
            borderTopLeftRadius: "0px",
            borderTopRightRadius: "0px",
          }}
        >
          <Grid Container direction="row">
            <TreatmentTypesTable theme="purple" />
          </Grid>
        </div>
      </TabPanel>

      <TabPanel value={tabValue} index={7}>
        <div
          style={{
            marginBottom: "20px",
            paddingTop: "5px",
            padding: "20px",
            backgroundColor: "white",
            borderRadius: "10px",
            borderTopLeftRadius: "0px",
            borderTopRightRadius: "0px",
          }}
        >
          <Grid Container direction="row">
            <DailyScheduleTable
              theme="purple"
              handleOpenAlert={handleOpenAlert}
              handleSetAlertMessage={handleSetAlertMessage}
            />
          </Grid>
        </div>
      </TabPanel>
    </GlobalContainer>
  );
};

export default Settings;
